module.exports = __webpack_public_path__ + "static/load-4ef15b0520a19e78ba214627f8667fc6.gif";